import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../../models/usuarios.service';
import { Fornecedores } from '../../../../models/fornecedores.model';
import { AngularFirestore } from '../../../../node_modules/angularfire2/firestore';

@Component({
    selector: 'google-maps',
    templateUrl: 'google-maps.component.html' ,
    styles: [``]
})
export class GoogleMapsComponent implements OnInit {
    regiao:string = 'Atibaia-SP';
    items:any[] = [];
    fornecedores : Fornecedores;
    constructor(
        private users:UsersService,
        private db: AngularFirestore
    ) {

      if (users.regiaoLogada!=null){
          this.regiao = users.regiaoLogada;
      }
      
     }

    ngOnInit(): void {
        this.fornecedores = new Fornecedores(this.db,false);
        this.fornecedores.snapshot(w=>{
           return w.where(this.regiao,'==',true).where('inativo','==',false);
        }, d=>{
          this.items = d;
        });
     }

}
